'use strict';

var TDChartNumberOfStopsAggregationFactory = function TDChartNumberOfStopsAggregationFactory(DataAggregationFactory, ExtractMetricKeysService) {
  function TDChartNumberOfStopsAggregation() {
    DataAggregationFactory.call(this, 'service', 'thematic-demand-chart-service-number-of-stops');
  }
  TDChartNumberOfStopsAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  TDChartNumberOfStopsAggregation.constructor = DataAggregationFactory;
  TDChartNumberOfStopsAggregation.prototype.aggregate = function (data, metrics) {
    var aggregationFunction = this.getAggregationFunction(metrics);
    var aggregatedNumberOfStops = {};
    var reducedEntry, metricKeys, keysLength, keys;
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      if (Array.isArray(aggregatedNumberOfStops[data[index].numberOfStops])) {
        aggregatedNumberOfStops[data[index].numberOfStops].push(data[index]);
      } else {
        aggregatedNumberOfStops[data[index].numberOfStops] = [data[index]];
      }
    }
    keys = Object.keys(aggregatedNumberOfStops);
    for (index = 0, keysLength = keys.length; index < keysLength; index++) {
      reducedEntry = {};
      reducedEntry.label = keys[index];
      metricKeys = ExtractMetricKeysService.extract(aggregatedNumberOfStops[keys[index]][0]);
      aggregationFunction(aggregatedNumberOfStops[keys[index]], metricKeys, reducedEntry);
      aggregatedNumberOfStops[keys[index]] = reducedEntry;
    }
    return this.sortAggregationResults(aggregatedNumberOfStops);
  };
  return TDChartNumberOfStopsAggregation;
};
TDChartNumberOfStopsAggregationFactory.$inject = ['DataAggregationFactory', 'ExtractMetricKeysService'];
module.exports = TDChartNumberOfStopsAggregationFactory;